/**
 * Classifies a failed start-training request into the locale key that
 * explains it, so a 409 (already starting elsewhere), a 404 (character not
 * owned) and a network failure each say something different rather than all
 * looking like a no-op click.
 */
export function startTrainingErrorKey(error) {
    const status = error?.response?.status;
    if (status === 409) return 'fightHud.startTrainingErrorConflict';
    if (status === 404) return 'fightHud.startTrainingErrorNotFound';
    return 'fightHud.startTrainingErrorGeneric';
}
